import appConfig from '@nerdwallet/app-config';
import CreditCard from '@nerdwallet/react-icon/nerdwallet-brand/CreditCard';
import Investment from '@nerdwallet/react-icon/nerdwallet-brand/Investment';
import Business from '@nerdwallet/react-icon/nerdwallet-brand/Business';
import StudentLoans from '@nerdwallet/react-icon/nerdwallet-brand/StudentLoans';
import Banking from '@nerdwallet/react-icon/nerdwallet-brand/Banking';
import Travel from '@nerdwallet/react-icon/nerdwallet-brand/Travel';
import PersonalLoans from '@nerdwallet/react-icon/nerdwallet-brand/PersonalLoans';
import Mortgage from '@nerdwallet/react-icon/nerdwallet-brand/Mortgage';
import Insurance from '@nerdwallet/react-icon/nerdwallet-brand/Insurance';

export default {
  // to break title into two lines, add \n where you want the lines to split
  title: 'Make smart decisions with\nside-by-side comparisons',
  backgroundImageUrl: `${appConfig.ASSETS_URL}/images/homepage/tab1-background.svg`,
  tabs: [
    {
      id: 'credit_cards',
      title: 'Credit cards',
      icon: CreditCard,
      subtitle: 'The right credit card is right here',
      description:
        'Looking for a card that earns travel points, cash back, or rewards? Our side-by-side comparisons and objective reviews can help you make the smartest decision.',
      primaryButtonText: 'compare credit cards',
      primaryButtonUrl: '/the-best-credit-cards',
      secondaryButtonText: 'explore guides and tips',
      secondaryButtonUrl: '/hub/category/credit-cards',
    },
    {
      id: 'travel',
      title: 'Travel',
      icon: Travel,
      subtitle: 'Get rewards for the way you travel',
      description:
        'Want to earn more points or miles? Our straightforward comparisons and objective reviews can help you decide which rewards programs best match your travel style.',
      primaryButtonText: 'compare rewards cards',
      primaryButtonUrl: '/best/credit-cards/travel',
      secondaryButtonText: 'explore guides and tips',
      secondaryButtonUrl: '/hub/category/travel',
    },
    {
      id: 'small_business',
      title: 'Small Business',
      icon: Business,
      subtitle: 'Your right fit for financing is here',
      description:
        'Find and compare SBA loans, invoice financing, and other options for your business. Personalized matches and objective reviews help you make the smartest decision.',
      primaryButtonText: 'compare business loans',
      primaryButtonUrl:
        '/best/small-business/small-business-loans/compare-financing',
      secondaryButtonText: 'explore guides and tips',
      secondaryButtonUrl: '/hub/category/small-business',
    },
    {
      id: 'personal_loans',
      title: 'Personal Loans',
      icon: PersonalLoans,
      subtitle: 'Borrow wisely with the right loan',
      description: `When you need a personal loan, it's smart to shop around. Our loan comparisons, objective reviews, and payment calculators make it easier to choose one with confidence.`,
      primaryButtonText: 'compare personal loans',
      primaryButtonUrl: '/personal-loans/pre-qualify',
      secondaryButtonText: 'explore guides and tips',
      secondaryButtonUrl: '/hub/category/personal-loans',
    },
    {
      id: 'banking',
      title: 'Banking',
      icon: Banking,
      subtitle: 'Find a bank for the way you save',
      description:
        'Keep your cash in a bank account that fits your needs.  Compare options and dig into the details with objective reviews that help you make smart decisions.',
      primaryButtonText: 'compare savings accounts',
      primaryButtonUrl: '/best/banking/high-yield-online-savings-accounts',
      secondaryButtonText: 'explore guides and tips',
      secondaryButtonUrl: '/hub/category/banking',
    },
    {
      id: 'mortgages',
      title: 'Mortgages',
      icon: Mortgage,
      subtitle: 'Home loans that match your goals',
      description:
        'Buying or refinancing a home? Our rate comparisons, mortgage insights, and objective lender reviews can help you make the smartest home-financing decision.',
      primaryButtonText: 'compare mortgage quotes',
      primaryButtonUrl: '/mortgages/top-mortgage-lenders',
      secondaryButtonText: 'explore guides and tips',
      secondaryButtonUrl: '/hub/category/mortgages',
    },
    {
      id: 'insurance',
      title: 'Insurance',
      icon: Insurance,
      subtitle: 'Discover the right insurance for you',
      description:
        'Compare and find insurance for your life, home, car, and more. Our comparisons and objective reviews can help you decide on the smartest insurance carriers for you.',
      primaryButtonText: 'compare car insurance',
      primaryButtonUrl: '/a/insurance/car-insurance',
      secondaryButtonText: 'explore guides and tips',
      secondaryButtonUrl: '/hub/category/insurance',
    },
    {
      id: 'investing',
      title: 'Investing',
      icon: Investment,
      subtitle: 'Zero in on investments that fit you',
      description: `Whether you're looking at stocks, IRAs, or crypto, our comparisons and objective reviews can help you make strategic decisions about your next investment accounts.`,
      primaryButtonText: 'compare online brokers',
      primaryButtonUrl: '/best/investing/online-brokers-for-stock-trading',
      secondaryButtonText: 'explore guides and tips',
      secondaryButtonUrl: '/hub/category/investing',
    },
    {
      id: 'student_loans',
      title: 'Student Loans',
      icon: StudentLoans,
      subtitle: 'Find the right student loan for you',
      description:
        'Need help paying for college? Compare offers from multiple private lenders and make smart borrowing decisions with objective reviews and loan calculators.',
      primaryButtonText: 'compare student loans',
      primaryButtonUrl: '/best/loans/student-loans/private-student-loans',
      secondaryButtonText: 'explore guides and tips',
      secondaryButtonUrl: '/hub/category/student-loans',
    },
  ],
};
